/** Código de banco Operación/Campo: no aplica Meridian / gestión de tareas. */
export const CODIGO_BANCO_CAMPO = 'OP-CAMPO';

/**
 * Convierte porcentaje 0–100 del sistema de gestión de tareas a escala 1–5.
 * Bandas: 0–30→1, 31–45→2, 46–60→3, 61–90→4, 91–100→5.
 */
export function porcentajeAEscala1a5(porcentaje) {
  const n = Number(porcentaje);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  if (n <= 30) return 1;
  if (n <= 45) return 2;
  if (n <= 60) return 3;
  if (n <= 90) return 4;
  return 5;
}

export function aplicaMedicionMeridian(codigoBanco) {
  return Boolean(codigoBanco) && codigoBanco !== CODIGO_BANCO_CAMPO;
}

/**
 * Promedio integral con pesos del período (por defecto 50/30/20).
 * Componentes ausentes (null/≤0 HSEQ) se excluyen y se reescalan pesos.
 */
export function calcularPromedioIntegral({
  promedioCompetencias,
  promedioMeridian,
  promedioHseq = null,
  pesoCompetencias = 50,
  pesoMeridian = 30,
  pesoHseq = 20,
  aplicaMeridian = true,
}) {
  const partes = [];
  const comp = Number(promedioCompetencias);
  if (Number.isFinite(comp) && comp > 0) {
    partes.push({ valor: comp, peso: pesoCompetencias });
  }
  if (aplicaMeridian) {
    const mer = Number(promedioMeridian);
    if (Number.isFinite(mer) && mer > 0) {
      partes.push({ valor: mer, peso: pesoMeridian });
    }
  }
  const hseq = Number(promedioHseq);
  if (Number.isFinite(hseq) && hseq > 0) {
    partes.push({ valor: hseq, peso: pesoHseq });
  }
  if (partes.length === 0) return 0;
  const pesoTotal = partes.reduce((s, p) => s + p.peso, 0);
  const suma = partes.reduce((s, p) => s + p.valor * (p.peso / pesoTotal), 0);
  return Number(suma.toFixed(2));
}
